import { PublicClientApplication } from "@azure/msal-browser";
import config from "../../config";

export const msalConfig = {
  auth: {
    clientId: config.msal.clientId,
    authority: config.msal.authority,
    redirectUri: config.msal.redirectUri,
    postLogoutRedirectUri: config.msal.postLogoutRedirectUri,

    // 🔥 ADD THIS (CRITICAL FIX)
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile"],
};

export const msalInstance = new PublicClientApplication(msalConfig);